import type { Underlying } from 'models/underlying';

type GridCellHighlightResolver = (rowIndex: number, columnId: string) => string | undefined;
export type UnderlyingCellHighlightResolver = (underlyingId: string, columnId: string) => string | undefined;

export function buildUnderlyingFlatIndexById(underlyings: readonly Underlying[]): Readonly<Record<string, number>> {
  return underlyings.reduce<Record<string, number>>((accumulator, underlying, rowIndex) => {
    accumulator[underlying.id] = rowIndex;
    return accumulator;
  }, {});
}

export function createUnderlyingCellHighlightResolver(
  getGridCellHighlight: GridCellHighlightResolver,
  underlyings: readonly Underlying[],
): UnderlyingCellHighlightResolver {
  const rowIndexById = buildUnderlyingFlatIndexById(underlyings);

  return (underlyingId, columnId) => {
    const rowIndex = rowIndexById[underlyingId];
    if (rowIndex === undefined) {
      return undefined;
    }
    return getGridCellHighlight(rowIndex, columnId);
  };
}
